import { KYMW9005Model } from '../kymw9005.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 関連会社ユーザの更新を行う。
 *
 * @export API通信成功時の処理
 * @class UpdateAssociatedUserManagement
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateAssociatedUserManagementService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9005Model;
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateAssociatedUserManagementService
   */
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * 関連会社ユーザ情報更新
   *
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        updateAssociatedUserManagement: {
          condition: {
            AssociatedUserId: this.model.associatedUserId,
            AssociatedUserType: this.model.associatedUserType,
            AssociatedUserName: this.model.associatedUserName,
            AssociatedUserNameKana: this.model.associatedUserNameKana,
            AuthoritySetId: this.model.authoritySetId,
            AssociatedCompanyId: this.model.associatedCompanyId,
            IsEnabled: this.model.isEnabled
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9005Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof UpdateAssociatedUserManagementService
   */
  execute(model: KYMW9005Model, successFunc: Function = null):void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('updateAssociatedUserManagement', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateAssociatedUserManagementService
   */
  success(data: any):void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
